/**
 * SaaS auth "sliding" — capa JS de la vista única login / register / forgot.
 *
 * La ANIMACIÓN es 100% CSS (radio-hack en saas-auth.css); el servidor marca la
 * pantalla de cada URL (deep-links sin JS). Este módulo añade, por secciones:
 *
 *   1 · URL-sync    — pushState al deslizar, popstate (atrás/adelante) marca el
 *                     radio (misma transición CSS que un clic), título y
 *                     enlaces de idioma siguen a la pantalla visible. Respeta
 *                     el prefijo de idioma del path y conserva la query.
 *   2 · Validación  — instantánea en cliente al enviar (required / email /
 *                     política de contraseña / confirmación / términos), con
 *                     los mismos estilos que los errores del servidor. La
 *                     política llega en data-password-policy (PasswordPolicy,
 *                     fuente única server↔cliente) y los textos en data-jsval.
 *   3 · Red         — submit por fetch con Accept: JSON:
 *                       2xx {redirect} → location.assign (login / registro)
 *                       2xx {message}  → caja verde in situ (forgot)
 *                       422 {errors}   → errores por campo + shake
 *                       429 / 419 / red → aviso en el formulario
 *   4 · bfcache     — volver con atrás no deja botones en estado busy.
 *
 * Sin fetch/pushState no se intercepta nada: el POST clásico y los deep-links
 * del servidor siguen siendo el camino completo (progressive enhancement).
 * Los errores (propios o del servidor) llevan data-almc-auth-error-for="<name>"
 * y se limpian en cuanto el usuario corrige el campo.
 */
(function () {
    'use strict';

    // El stage es el sliding ([data-almc-auth]) o el reto 2FA
    // ([data-almc-auth-2fa]) — comparten bundle, mensajes y pipeline fetch.
    var stage = document.querySelector('[data-almc-auth]') || document.querySelector('[data-almc-auth-2fa]');
    if (!stage) return;

    function readJson(attr) {
        try {
            return JSON.parse(stage.getAttribute(attr) || '{}');
        } catch (e) {
            return {};
        }
    }

    var SCREENS = ['login', 'register', 'forgot'];
    var PATH_RE = /^(\/(?:es|en|fr|ca))\/dash\/auth\/(login|register|forgot)\/?$/;
    var TITLES = readJson('data-titles');
    var MSG = readJson('data-jsval');
    var PW = readJson('data-password-policy');
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    var radios = {};
    SCREENS.forEach(function (s) {
        radios[s] = document.getElementById('almc-auth-r-' + s);
    });

    /* ── 1 · Sincronización de URL (pushState / popstate / título / idiomas) ── */

    function currentScreen() {
        for (var i = 0; i < SCREENS.length; i++) {
            if (radios[SCREENS[i]] && radios[SCREENS[i]].checked) return SCREENS[i];
        }
        return 'login';
    }

    /** Prefijo de idioma REAL del path actual (fallback: data-locale del server). */
    function localePrefix() {
        var m = window.location.pathname.match(PATH_RE);
        return m ? m[1] : '/' + (stage.getAttribute('data-locale') || 'es');
    }

    function urlFor(screen) {
        return localePrefix() + '/dash/auth/' + screen + window.location.search;
    }

    /** Los enlaces de idioma pasan a apuntar a la pantalla visible. Se reescribe
        SOLO el final del pathname (anclado con $): una query que contuviera
        "/dash/auth/…" (p.ej. ?next=…) jamás debe tocarse. */
    function syncLangLinks(screen) {
        var links = document.querySelectorAll('a[data-almc-auth-lang]');
        for (var i = 0; i < links.length; i++) {
            try {
                var u = new URL(links[i].href);
                u.pathname = u.pathname.replace(
                    /\/dash\/auth\/(?:login|register|forgot)\/?$/,
                    '/dash/auth/' + screen
                );
                links[i].href = u.href;
            } catch (e) { /* href raro: se deja como está */ }
        }
    }

    function applyChrome(screen) {
        if (TITLES[screen]) document.title = TITLES[screen];
        syncLangLinks(screen);
    }

    if (stage.hasAttribute('data-almc-auth') && 'pushState' in history) {
        // Clic/teclado en una pantalla → URL + título acompañan a la animación.
        SCREENS.forEach(function (screen) {
            if (!radios[screen]) return;
            radios[screen].addEventListener('change', function () {
                if (!this.checked) return;
                history.pushState({ almcAuth: screen }, '', urlFor(screen));
                applyChrome(screen);
            });
        });

        // Atrás/adelante → marcar el radio reproduce la transición (asignar
        // checked por código no dispara change: no hay pushState doble).
        window.addEventListener('popstate', function () {
            var m = window.location.pathname.match(PATH_RE);
            if (!m) return;
            if (radios[m[2]] && !radios[m[2]].checked) radios[m[2]].checked = true;
            applyChrome(m[2]);
        });

        // Estado inicial: título bonito + state coherente para el primer atrás.
        history.replaceState({ almcAuth: currentScreen() }, '', window.location.href);
        applyChrome(currentScreen());
    }

    // Los labels-enlace (role=button, tabindex=0) deben responder a Enter y
    // Espacio como cualquier botón: activarlos marca su radio (mismo efecto
    // que el clic) y la transición CSS + pushState siguen su curso normal.
    document.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Enter' && ev.key !== ' ') return;
        var t = ev.target;
        if (t && t.matches && t.matches('label[for^="almc-auth-r-"]')) {
            ev.preventDefault();
            t.click();
        }
    });

    /* ── 2 · Validación instantánea en cliente ─────────────────────────────── */

    function errorNode(name, msg, block) {
        var p = document.createElement('p');
        p.className = 'almc-auth-error' + (block ? ' almc-auth-error--block' : '');
        p.setAttribute('role', 'alert');
        p.setAttribute('data-almc-auth-error-for', name);
        p.textContent = msg;
        return p;
    }

    function setError(input, msg) {
        clearError(input);
        input.setAttribute('aria-invalid', 'true');

        var wrap = input.closest('.almc-auth-field');
        if (wrap) {
            wrap.classList.add('almc-auth-field--invalid');
            if (wrap.classList.contains('almc-auth-field--errblock')) {
                // Campo en columna con mensaje largo: el error va como bloque a
                // ancho completo tras su grid (misma colocación que el servidor).
                var grid = wrap.closest('.almc-auth-grid2') || wrap;
                grid.parentNode.insertBefore(errorNode(input.name, msg, true), grid.nextSibling);
            } else {
                wrap.appendChild(errorNode(input.name, msg, false));
            }
            return;
        }

        var check = input.closest('.almc-auth-check');
        if (check) {
            check.classList.add('almc-auth-check--invalid');
            check.parentNode.insertBefore(errorNode(input.name, msg, true), check.nextSibling);
        }
    }

    function clearError(input) {
        input.removeAttribute('aria-invalid');
        var form = input.form;
        if (form) {
            var errs = form.querySelectorAll('[data-almc-auth-error-for="' + input.name + '"]');
            Array.prototype.forEach.call(errs, function (p) { p.parentNode.removeChild(p); });
        }
        var wrap = input.closest('.almc-auth-field');
        if (wrap) wrap.classList.remove('almc-auth-field--invalid');
        var check = input.closest('.almc-auth-check');
        if (check) check.classList.remove('almc-auth-check--invalid');
    }

    function clearAllErrors(form) {
        Array.prototype.forEach.call(form.querySelectorAll('.almc-auth-input, input[type="checkbox"]'), clearError);
        var flash = form.querySelector('.almc-auth-flash[data-almc-auth-js]');
        if (flash) flash.parentNode.removeChild(flash);
    }

    /** La política llega del servidor; sin spec no se bloquea nada en cliente. */
    function passwordSatisfiesPolicy(v) {
        if (PW.min && v.length < PW.min) return false;
        if (PW.upper && !/[A-Z]/.test(v)) return false;
        if (PW.lower && !/[a-z]/.test(v)) return false;
        if (PW.digit && !/[0-9]/.test(v)) return false;
        if (PW.symbol && !/[^\w]/.test(v)) return false;
        return true;
    }

    /** Devuelve los inputs con error, en orden DOM (el primero recibe focus). */
    function validate(form) {
        var bad = [];
        var isRegister = form.classList.contains('almc-auth-form--register');

        Array.prototype.forEach.call(form.querySelectorAll('.almc-auth-input'), function (input) {
            var v = (input.value || '').trim();
            if (input.required && !v) {
                setError(input, MSG.required); bad.push(input); return;
            }
            if (input.type === 'email' && v && !EMAIL_RE.test(v)) {
                setError(input, MSG.email); bad.push(input); return;
            }
            if (isRegister && input.name === 'password' && v && !passwordSatisfiesPolicy(input.value)) {
                setError(input, MSG.password_weak); bad.push(input); return;
            }
            if (input.name === 'password_confirmation') {
                var pw = form.querySelector('input[name="password"]');
                if (pw && input.value !== pw.value) {
                    setError(input, MSG.password_match); bad.push(input);
                }
            }
        });

        Array.prototype.forEach.call(form.querySelectorAll('input[type="checkbox"][required]'), function (checkbox) {
            if (checkbox.checked) return;
            setError(checkbox, checkbox.getAttribute('data-error-message') || MSG.terms);
            bad.push(checkbox);
        });

        return bad;
    }

    function shake(form) {
        var card = form.querySelector('.almc-auth-card');
        card.classList.remove('almc-auth-shake');
        void card.offsetWidth; // reinicia la animación aunque ya sonara antes
        card.classList.add('almc-auth-shake');
    }

    /* ── 3 · Envío por fetch (sin recarga) ─────────────────────────────────── */

    /** Aviso a nivel de formulario (throttle, sesión caducada, red, éxito forgot). */
    function formFlash(form, msg, mod, extraClass) {
        var card = form.querySelector('.almc-auth-card');
        var old = card.querySelector('.almc-auth-flash[data-almc-auth-js]');
        if (old) old.parentNode.removeChild(old);
        var div = document.createElement('div');
        div.className = 'almc-auth-flash almc-auth-flash--' + mod + (extraClass ? ' ' + extraClass : '');
        div.setAttribute('role', mod === 'ok' ? 'status' : 'alert');
        div.setAttribute('data-almc-auth-js', '1');
        div.textContent = msg;
        var lead = card.querySelector('.almc-auth-lead');
        lead ? lead.parentNode.insertBefore(div, lead.nextSibling) : card.insertBefore(div, card.firstChild);
    }

    function setBusy(form, busy) {
        form.dataset.almcBusy = busy ? '1' : '';
        var btn = form.querySelector('.almc-auth-btn');
        if (btn) {
            btn.disabled = !!busy;
            btn.classList.toggle('almc-auth-btn--busy', !!busy);
        }
    }

    function renderServerErrors(form, errors) {
        var first = null;
        Object.keys(errors).forEach(function (name) {
            var input = form.querySelector('[name="' + name + '"]');
            var msg = Array.isArray(errors[name]) ? errors[name][0] : String(errors[name]);
            if (input) {
                setError(input, msg);
                if (!first) first = input;
            } else {
                formFlash(form, msg, 'ko');
            }
        });
        if (first) first.focus();
    }

    function handleResponse(form, status, data) {
        var ok = status >= 200 && status < 300;

        if (ok && data.redirect) {
            // Defensa en profundidad: el servidor solo emite URLs propias
            // (url()/postAuthTarget), pero si algún día un parámetro controlable
            // acabara en {redirect}, jamás debe sacarnos del origen.
            var dest = null;
            try { dest = new URL(data.redirect, window.location.origin); } catch (e) { /* inválida */ }
            if (dest && dest.origin === window.location.origin) {
                // Mantener el botón en busy: estamos navegando ya.
                window.location.assign(dest.href);
                return;
            }
        }

        setBusy(form, false);

        if (status === 422 && data.errors) {
            renderServerErrors(form, data.errors);
            shake(form);
        } else if (status === 429) {
            formFlash(form, MSG.throttled, 'warn');
            shake(form);
        } else if (status === 419) {
            // CSRF caducado (página abierta demasiado tiempo): recargar rehace el token.
            formFlash(form, MSG.expired, 'warn');
        } else if (ok && data.message) {
            formFlash(form, data.message, 'ok',
                form.classList.contains('almc-auth-form--forgot') ? 'almc-auth-sent' : '');
        } else {
            formFlash(form, MSG.error_generic, 'ko');
            shake(form);
        }
    }

    function submitAjax(form) {
        setBusy(form, true);
        fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        }).then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (data) {
                handleResponse(form, res.status, data);
            });
        }).catch(function () {
            setBusy(form, false);
            formFlash(form, MSG.error_generic, 'ko');
            shake(form);
        });
    }

    if (typeof window.fetch === 'function' && MSG.required) {
        Array.prototype.forEach.call(document.querySelectorAll('.almc-auth-ajax'), function (form) {
            form.addEventListener('submit', function (ev) {
                ev.preventDefault();
                if (form.dataset.almcBusy === '1') return;
                clearAllErrors(form);
                var bad = validate(form);
                if (bad.length) {
                    shake(form);
                    bad[0].focus();
                    return;
                }
                submitAjax(form);
            });

            // Native feel: el error de un campo se esfuma en cuanto lo corriges.
            form.addEventListener('input', function (ev) {
                var t = ev.target;
                if (t && (t.classList.contains('almc-auth-input') || t.type === 'checkbox')) clearError(t);
            });
            form.addEventListener('change', function (ev) {
                if (ev.target && ev.target.type === 'checkbox') clearError(ev.target);
            });
        });
    }

    /* ── 4 · Reto 2FA: título, auto-submit a los 6 dígitos, reenvío ────────── */

    var twofa = document.querySelector('[data-almc-auth-2fa]');
    if (twofa) {
        if (twofa.getAttribute('data-title')) document.title = twofa.getAttribute('data-title');

        // Auto-submit al completar 6 dígitos (viaja por el pipeline fetch
        // genérico de la sección 3; los códigos de recuperación TOTP, más
        // largos, se envían con el botón).
        var codeInput = document.getElementById('almc-auth-2fa-code');
        if (codeInput) {
            codeInput.addEventListener('input', function () {
                var v = this.value;
                if (/^[0-9]{6}$/.test(v) && this.form.dataset.almcBusy !== '1' && this.form.requestSubmit) {
                    this.form.requestSubmit();
                }
            });
        }

        var waitEl = twofa.querySelector('[data-almc-2fa-wait]');
        var secEl = twofa.querySelector('[data-almc-2fa-sec]');
        var primaryBtn = twofa.querySelector('.almc-auth-2fa-resend-btn[data-channel=""]');

        function startResendTimer() {
            if (!waitEl || !secEl || !primaryBtn) return;
            var left = parseInt(waitEl.getAttribute('data-seconds'), 10) || 60;
            waitEl.style.display = '';
            secEl.textContent = left;
            primaryBtn.disabled = true;
            (function tick() {
                left--;
                if (left <= 0) {
                    waitEl.style.display = 'none';
                    primaryBtn.disabled = false;
                    return;
                }
                secEl.textContent = left;
                setTimeout(tick, 1000);
            })();
        }
        startResendTimer();

        Array.prototype.forEach.call(twofa.querySelectorAll('.almc-auth-2fa-resend-btn'), function (btn) {
            btn.addEventListener('click', function () {
                var form = twofa.querySelector('.almc-auth-ajax');
                var fd = new FormData();
                fd.append('_token', form.querySelector('input[name="_token"]').value);
                if (btn.getAttribute('data-channel')) fd.append('channel', btn.getAttribute('data-channel'));
                btn.disabled = true;
                fetch(twofa.getAttribute('data-resend-url'), {
                    method: 'POST',
                    body: fd,
                    credentials: 'same-origin',
                    headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                }).then(function (res) {
                    return res.json().catch(function () { return {}; }).then(function (data) {
                        if (res.ok && data.sent) {
                            formFlash(form, 'Código reenviado por ' + data.channel + ' a ' + data.recipient_masked, 'ok');
                            var chip = twofa.querySelector('[data-almc-2fa-recipient]');
                            if (chip && data.recipient_masked) chip.textContent = data.recipient_masked;
                            startResendTimer();                    // gobierna el botón primario
                            if (btn !== primaryBtn) btn.disabled = false;
                        } else {
                            btn.disabled = false;
                            if (res.status === 401) {
                                formFlash(form, MSG.expired, 'warn');
                            } else {
                                formFlash(form, (data && (data.error || data.message)) || MSG.error_generic, 'ko');
                            }
                        }
                    });
                }).catch(function () {
                    btn.disabled = false;
                    formFlash(form, MSG.error_generic, 'ko');
                });
            });
        });
    }

    /* ── 5 · bfcache: atrás no deja botones colgados en busy ───────────────── */

    window.addEventListener('pageshow', function (ev) {
        if (!ev.persisted) return;
        Array.prototype.forEach.call(document.querySelectorAll('.almc-auth-ajax'), function (form) {
            setBusy(form, false);
        });
    });
})();
